import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  getPhotos() {
    return API_URL.get(`/photo`);
  },
  getPages() {
    return API_URL.get(`/page?site=admin`);
  },
  addPhoto(photo: any) {
    return API_URL.post(`/photo`, photo, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  addPage(page: any) {
    return API_URL.post(`/page`, page, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  updatePhoto(photo: any) {
    return API_URL.put(`/photo`, photo, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  updatePage(page: any) {
    return API_URL.put(`/page`, page, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  deletePhoto(photoID: string) {
    return API_URL.delete(`/photo/${photoID}`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  deletePage(pageID: string) {
    return API_URL.delete(`/page/${pageID}`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
};
